import React, { PropTypes, Component } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import Notifications from 'react-notification-system-redux';
import { media } from 'style-utils';

import FbtHeader from './FbtHeader';
import DesktopNavigation from '../../components/common/Navigation/DesktopNavigation';
import Breakpoint from '../../utils/breakpoints';
import MobileNavigation from '../../components/common/Navigation/MobileNavigation';

const LayoutContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-grow: 1;

  ${media.mobileTablet`
    flex-direction: column;
  `}
`;

const PageContainer = styled.div`
  flex-grow: 1;
`;

class FbtLayout extends Component {
  render() {
    const { notifications, location } = this.props;

    return (
      <LayoutContainer>
        <Breakpoint name="desktop">
          <DesktopNavigation location={this.props.location} />
        </Breakpoint>
        <PageContainer>
          <FbtHeader location={location} homeRoute={this.props.homeRoute} />
          <MobileNavigation location={location} hideWhenScrolled={false} />
          {this.props.children}
          <Notifications
            notifications={notifications}
            // To disable all inline styles, just pass false to the prop style
            // eslint-disable-next-line react/style-prop-object
            style={false}
          />
        </PageContainer>
      </LayoutContainer>
    );
  }
}

FbtLayout.propTypes = {
  location: PropTypes.object,
  children: PropTypes.object,
  notifications: PropTypes.array,
  homeRoute: PropTypes.string,
};

const mapStateToProps = state => ({
  homeRoute: state.auth.config.homeRoute,
});

export default connect(mapStateToProps, {})(FbtLayout);



// WEBPACK FOOTER //
// ./src/layouts/fbt/FbtLayout.js